var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { compose } from '@ally/utilitarian';
import { InvestAccountName, DepositAccountName, } from '@ally/data-types-customization';
import { ownershipTypes } from './consts';
import { AccountType, AccountTypeToLabel, } from './selectorTypes';
export var filterExpiredAccount = function (_a) {
    var accountClosingDate = _a.accountClosingDate;
    if (!accountClosingDate) {
        return true;
    }
    var today = new Date();
    var dayDifference = today.getDate() - 60;
    var unixSixtyDaysAgo = today.setDate(dayDifference);
    var sixtyDaysAgo = new Date(unixSixtyDaysAgo).getTime();
    var isMoreThan60 = new Date(accountClosingDate).getTime() < sixtyDaysAgo;
    return !isMoreThan60;
};
export var filterByRetirementIndicator = function (isRetirementAccount) { return function (account) {
    return !!account.retirementIndicator === isRetirementAccount;
}; };
export var reduceInvestTotal = function (total, account) {
    var accountValueTotal = account.accountValueTotal;
    return total + Number(accountValueTotal);
};
var determineDepositAccountBalance = function (_a) {
    var accountType = _a.accountType, availableBalancePvtEncrypt = _a.availableBalancePvtEncrypt, currentBalancePvtEncrypt = _a.currentBalancePvtEncrypt;
    return accountType === 'CDA'
        ? currentBalancePvtEncrypt
        : availableBalancePvtEncrypt;
};
export var reduceDepositTotal = function (total, account) {
    var accountType = account.accountType, availableBalancePvtEncrypt = account.availableBalancePvtEncrypt, currentBalancePvtEncrypt = account.currentBalancePvtEncrypt;
    var accountBalance = determineDepositAccountBalance({
        accountType: accountType,
        availableBalancePvtEncrypt: availableBalancePvtEncrypt,
        currentBalancePvtEncrypt: currentBalancePvtEncrypt,
    });
    return total + Number(accountBalance);
};
export var checkOwnershipType = function (_a) {
    var ownershipType = _a.ownershipType;
    return ownershipTypes.includes(ownershipType);
};
var mapDepositAccountsForDropdown = function (account) {
    var accountNumber = account.accountNumberPvtEncrypt, accountStatus = account.accountStatus, unmappedAccountType = account.accountType, availableBalancePvtEncrypt = account.availableBalancePvtEncrypt, currentBalancePvtEncrypt = account.currentBalancePvtEncrypt, accountNickname = account.accountNickname, accountClosingDate = account.accountClosingDate, accountId = account.accountId, retirementIndicator = account.retirementIndicator;
    var accountType = AccountType[unmappedAccountType];
    var accountTypeLabel = AccountTypeToLabel[accountType];
    var balance = determineDepositAccountBalance({
        accountType: accountType,
        availableBalancePvtEncrypt: availableBalancePvtEncrypt,
        currentBalancePvtEncrypt: currentBalancePvtEncrypt,
    });
    return {
        accountType: accountType,
        accountTypeLabel: accountTypeLabel,
        nickname: accountNickname,
        accountId: accountId,
        accountNumber: accountNumber,
        accountStatus: accountStatus,
        balance: balance,
        retirementIndicator: retirementIndicator,
        accountClosingDate: accountClosingDate,
    };
};
export var mapInvestAccountsForDropdown = function (account) {
    var accountNumber = account.accountNumberPvtEncrypt, accountStatus = account.accountStatus, unmappedAccountType = account.accountType, accountValueTotal = account.accountValueTotal, accountNickname = account.accountNickname, webId = account.webId;
    var accountType = AccountType[unmappedAccountType];
    return {
        accountType: accountType,
        accountTypeLabel: AccountTypeToLabel[unmappedAccountType],
        nickname: accountNickname,
        accountNumber: accountNumber,
        accountStatus: accountStatus,
        balance: accountValueTotal,
        accountId: webId,
    };
};
export var sortByStatus = function (extraSort) { return function (a, b) {
    var getIsClosed = function (account) {
        return !!account.accountStatus.match(/closed/i);
    };
    var aIsClosed = getIsClosed(a);
    var bIsClosed = getIsClosed(b);
    if (aIsClosed && !bIsClosed) {
        return 1;
    }
    if (!aIsClosed && bIsClosed) {
        return -1;
    }
    if (extraSort) {
        return extraSort(a, b);
    }
    return 0;
}; };
var sortByOpenDate = function (extraSort) { return function (a, b) {
    var getOpenDate = function (_a) {
        var accountOpeningDate = _a.accountOpeningDate;
        return new Date(accountOpeningDate).getTime();
    };
    var aOpenDate = getOpenDate(a);
    var bOpenDate = getOpenDate(b);
    var order = aOpenDate - bOpenDate;
    if (extraSort && order === 0) {
        return extraSort(a, b);
    }
    return order;
}; };
var getPlanType = function (acct) {
    var _a;
    return (((_a = acct.retirementPlan) === null || _a === void 0 ? void 0 : _a.planType) || '').toUpperCase();
};
var sortByRetirementPlan = function (retirementPlans) {
    return function (extraSort) {
        return function (a, b) {
            var aRetPlan = getPlanType(a);
            var bRetPlan = getPlanType(b);
            var aIndex = retirementPlans.indexOf(aRetPlan);
            var bIndex = retirementPlans.indexOf(bRetPlan);
            var order = aIndex - bIndex;
            if (extraSort && order === 0) {
                return extraSort(a, b);
            }
            return order;
        };
    };
};
export var sortByAccountType = function (accountTypes) {
    return function (extraSort) {
        return function (a, b) {
            var aAcctType = a.accountType;
            var bAcctType = b.accountType;
            var aIndex = accountTypes.indexOf(aAcctType);
            var bIndex = accountTypes.indexOf(bAcctType);
            var order = aIndex - bIndex;
            if (extraSort && order === 0) {
                return extraSort(a, b);
            }
            return order;
        };
    };
};
var sortByStatusAndOpenDate = compose(sortByStatus, sortByOpenDate)();
var getCustomInvestAccountOrder = function (customizationOpts) {
    var orderedAccounts = [];
    customizationOpts === null || customizationOpts === void 0 ? void 0 : customizationOpts.forEach(function (_a) {
        var accountTypes = _a.accountTypes;
        accountTypes.forEach(function (_a) {
            var lob = _a.lob, name = _a.name, order = _a.order;
            if (lob === 'INVEST' && name in InvestAccountName) {
                orderedAccounts.push({ name: name, order: order });
            }
        });
    });
    orderedAccounts.sort(function (a, b) { return a.order - b.order; });
    return orderedAccounts;
};
var getCustomDepositAccountOrder = function (customizationOpts) {
    var orderedAccounts = [];
    customizationOpts === null || customizationOpts === void 0 ? void 0 : customizationOpts.forEach(function (_a) {
        var accountTypes = _a.accountTypes;
        accountTypes.forEach(function (_a) {
            var lob = _a.lob, name = _a.name, order = _a.order;
            if (lob === 'DEPOSIT' && name in DepositAccountName) {
                orderedAccounts.push({ name: name, order: order });
            }
        });
    });
    orderedAccounts.sort(function (a, b) { return a.order - b.order; });
    return orderedAccounts;
};
var sortDepositAccounts = function (accountsToSort, customizationOpts) {
    getCustomDepositAccountOrder(customizationOpts).forEach(function (_a) {
        var name = _a.name, order = _a.order;
        accountsToSort[name].order = order;
    });
    /**
     * Accounts without an order value are required to be placed at the front
     * of the array in their default order. Hence the `|| 0` to give `undefined`
     * order values a lower value in the sort order than defined values, which
     * are indexed from 1.
     */
    return Object.values(accountsToSort)
        .sort(function (a, b) { return (a.order || 0) - (b.order || 0); })
        .map(function (_a) {
        var acct = _a.acct;
        return acct;
    });
};
export var formatInvestAccountsForDropdown = function (accountSummary, customizationOpts) {
    var accountOrder = getCustomInvestAccountOrder(customizationOpts);
    var orderedAccountNames = [
        // INVW - Wealth Portfolio
        InvestAccountName.INVW,
        // INVA - Robo Portfolio
        InvestAccountName.INVA,
        // INVS - Self-directed
        InvestAccountName.INVS,
    ].sort(function (a, b) {
        var _a, _b;
        return (((_a = accountOrder.find(function (acct) { return acct.name === a; })) === null || _a === void 0 ? void 0 : _a.order) || 0) -
            (((_b = accountOrder.find(function (acct) { return acct.name === b; })) === null || _b === void 0 ? void 0 : _b.order) || 0);
    });
    var investGroup = accountSummary.sort(compose(sortByAccountType(orderedAccountNames), sortByStatus)());
    return investGroup.map(mapInvestAccountsForDropdown);
};
export var formatDepositAccountsForDropdown = function (ddaAccts, mmaAccts, sdaAccts, cmgAccts, cdaAccts, retAccts, customizationOpts) {
    var _a;
    // CHECKING ACCOUNTS
    var interestCheckingGroup = (ddaAccts || [])
        .sort(sortByStatusAndOpenDate)
        .filter(filterExpiredAccount);
    // SAVINGS ACCOUNTS
    var otherDepAccountsGroup = __spread((mmaAccts || []), (sdaAccts || []), (cmgAccts || [])).sort(compose(sortByStatus, sortByAccountType(['MMA', 'SDA', 'CMG']), sortByOpenDate)())
        .filter(filterExpiredAccount);
    // CD ACCOUNTS
    var cdGroup = (cdaAccts || [])
        .sort(sortByStatusAndOpenDate)
        .filter(filterExpiredAccount);
    // IRA ACCOUNTS
    var retirementGroup = (retAccts || [])
        .sort(compose(sortByRetirementPlan(['SEP', 'ROTH', 'TRADITIONAL']), sortByStatus, sortByAccountType(['SDA', 'CDA']), sortByOpenDate)())
        .filter(filterExpiredAccount);
    var sortedAccounts = sortDepositAccounts((_a = {},
        _a[DepositAccountName.CHECKING] = { acct: interestCheckingGroup },
        _a[DepositAccountName.SAVINGS] = { acct: otherDepAccountsGroup },
        _a[DepositAccountName.CD] = { acct: cdGroup },
        _a[DepositAccountName.IRA] = { acct: retirementGroup },
        _a), customizationOpts);
    /**
     * Here, the above array items are run
     * through the reducer below. The order of items in the
     * array is important here, since this determines the order
     * in which they will display in the account dropdown
     * (or wherever else this data is used). The sole responsibility
     * of the reducer here is to map each items (which are arrays,
     * themselves) through `mapDepositAccountsForDropdown`, and
     * then spread the results into a single array.
     * `mapDepositAccountsForDropdown` maps each of the account
     * objects into a format that is consumable for the UI.
     */
    return sortedAccounts.reduce(function (acc, accounts) {
        return __spread(acc, accounts.map(mapDepositAccountsForDropdown));
    }, []);
};
export var getByType = function () {
    var accTypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        accTypes[_i] = arguments[_i];
    }
    return function (accountSummary) {
        return accountSummary.filter(function (_a) {
            var accountType = _a.accountType;
            var hasType = accTypes.includes(accountType);
            return hasType;
        });
    };
};
//# sourceMappingURL=utils.js.map